// © Microsoft Corporation. All rights reserved.

/**
 * Set of resource string used by article reader components
 */
const ViewsStringResource = {
    article: "article",
    image: "image",
    video: "video",
    gallery: "gallery",
    exitFullscreen: "Exit Full Screen",
    fullscreen: "Full Screen",
    nextSlide: "Next Slide",
    previousSlide: "Previous Slide",
    publishedSecondAgo: "second ago",
    publishedSecondsAgo: "seconds ago",
    publishedMinuteAgo: "minute ago",
    publishedMinutesAgo: "minutes ago",
    publishedHourAgo: "hr ago",
    publishedHoursAgo: "hrs ago",
    publishedDayAgo: "day ago",
    publishedDaysAgo: "days ago",
    gallerySlideError: "Something went wrong while loading this slide.",
    sharingToolbarLoadFailure: "Failed to render sharing toolbar.",
    invalidCMSIdErrorFormat: "Invalid {0} document. Please try a different one.",
    documentDataFetchErrorFormat: "Whoops! This {0} doesn’t exist or can’t be found. Please try a different one.",
    intraArticleComponentErrorFormat: "This {0} doesn’t exist or can’t be found.",
    gallerySlideCountFormat: "{0}/{1} SLIDES",
    gallerySlideCountFullScreenFormat: "{0} of {1}",
    seeOnProviderSite: "See on {0}",
    socialFeedNotSupported: "Social media feed type not supported.",
    articleReadMoreText: "show more"
};

export { ViewsStringResource };